<template lang="pug">
.termsPage
  page-title(back-prev) {{ $t('pages.terms') }}

  div
    nl2br(tag="p" :text="terms")
</template>

<script>
import Nl2br from 'vue-nl2br'
const PageTitle = () => import('@/components/molecules/PageTitle')
import Head from '~/assets/scripts/Head'
export default {
  components: { PageTitle, Nl2br },
  computed: {
    terms() {
      return require(`~/static/documents/terms_${this.$i18n.locale == 'ja' ? 'ja' : 'en'}.txt`).default
    },
  },
  head() {
    const head = new Head({
      title: `${this.$t('pages.terms')} | ${this.$t('common.meta.title')}`,
      url: `${this.$env.siteUrl}terms`,
    })
    return head.get()
  },
}
</script>

<style lang="scss" scoped>
.termsPage {
  >div {
    font-size: 0.8rem;
    line-height: 2;
    text-align: center;

    @media (min-width: $breakpoint) {
      font-size: 1rem;
    }

    p {
      display: inline-block;
      text-align: left;
    }
  }

  >ul {
    margin-top: 1rem;

    @media (min-width: $breakpoint) {
      margin-top: 2rem;
    }
  }
}
</style>
